import * as ambassadorWixStoresCatalogV3Product from './stores-catalog-v3-product-products-v-3.http.js';
import * as ambassadorWixStoresCatalogV3ProductTypes from './stores-catalog-v3-product-products-v-3.types.js';
import * as ambassadorWixStoresCatalogV3ProductUniversalTypes from './stores-catalog-v3-product-products-v-3.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createProduct(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.CreateProductRequest,
  ambassadorWixStoresCatalogV3ProductTypes.CreateProductRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.CreateProductResponse,
  ambassadorWixStoresCatalogV3ProductTypes.CreateProductResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.createProduct(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/products',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createProductWithInventory(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.CreateProductWithInventoryRequest,
  ambassadorWixStoresCatalogV3ProductTypes.CreateProductWithInventoryRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.CreateProductWithInventoryResponse,
  ambassadorWixStoresCatalogV3ProductTypes.CreateProductWithInventoryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.createProductWithInventory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/products-with-inventory',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateProduct(): __PublicMethodMetaInfo<
  'PATCH',
  { productId: string },
  ambassadorWixStoresCatalogV3ProductUniversalTypes.UpdateProductRequest,
  ambassadorWixStoresCatalogV3ProductTypes.UpdateProductRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.UpdateProductResponse,
  ambassadorWixStoresCatalogV3ProductTypes.UpdateProductResponse
> {
  const payload = { product: { id: ':productId' } } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.updateProduct(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/products/{product.id}',
    pathParams: { productId: 'productId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateProductWithInventory(): __PublicMethodMetaInfo<
  'PATCH',
  { productId: string },
  ambassadorWixStoresCatalogV3ProductUniversalTypes.UpdateProductWithInventoryRequest,
  ambassadorWixStoresCatalogV3ProductTypes.UpdateProductWithInventoryRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.UpdateProductWithInventoryResponse,
  ambassadorWixStoresCatalogV3ProductTypes.UpdateProductWithInventoryResponse
> {
  const payload = { product: { id: ':productId' } } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.updateProductWithInventory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/products-with-inventory/{product.id}',
    pathParams: { productId: 'productId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateProducts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkCreateProductsRequest,
  ambassadorWixStoresCatalogV3ProductTypes.BulkCreateProductsRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkCreateProductsResponse,
  ambassadorWixStoresCatalogV3ProductTypes.BulkCreateProductsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkCreateProducts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateProductsWithInventory(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkCreateProductsWithInventoryRequest,
  ambassadorWixStoresCatalogV3ProductTypes.BulkCreateProductsWithInventoryRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkCreateProductsWithInventoryResponse,
  ambassadorWixStoresCatalogV3ProductTypes.BulkCreateProductsWithInventoryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkCreateProductsWithInventory(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products-with-inventory/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateProducts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkUpdateProductsRequest,
  ambassadorWixStoresCatalogV3ProductTypes.BulkUpdateProductsRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkUpdateProductsResponse,
  ambassadorWixStoresCatalogV3ProductTypes.BulkUpdateProductsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkUpdateProducts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateProductsWithInventory(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkUpdateProductsWithInventoryRequest,
  ambassadorWixStoresCatalogV3ProductTypes.BulkUpdateProductsWithInventoryRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkUpdateProductsWithInventoryResponse,
  ambassadorWixStoresCatalogV3ProductTypes.BulkUpdateProductsWithInventoryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkUpdateProductsWithInventory(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products-with-inventory/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateProductsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkUpdateProductsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkUpdateProductsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkUpdateProductsByFilterResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkUpdateProductsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkUpdateProductsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/update-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteProduct(): __PublicMethodMetaInfo<
  'DELETE',
  { productId: string },
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3DeleteProductRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3DeleteProductRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3DeleteProductResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3DeleteProductResponse
> {
  const payload = { productId: ':productId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.deleteProduct(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/products/{productId}',
    pathParams: { productId: 'productId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteProducts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkDeleteProductsRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkDeleteProductsRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkDeleteProductsResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkDeleteProductsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkDeleteProducts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteProductsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkDeleteProductsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkDeleteProductsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkDeleteProductsByFilterResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkDeleteProductsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkDeleteProductsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/delete-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getProduct(): __PublicMethodMetaInfo<
  'GET',
  { productId: string },
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3GetProductRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3GetProductRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3GetProductResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3GetProductResponse
> {
  const payload = { productId: ':productId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.getProduct(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/products/{productId}',
    pathParams: { productId: 'productId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getProductBySlug(): __PublicMethodMetaInfo<
  'GET',
  { slug: string },
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3GetProductBySlugRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3GetProductBySlugRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3GetProductBySlugResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3GetProductBySlugResponse
> {
  const payload = { slug: ':slug' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.getProductBySlug(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/products/slug/{slug}',
    pathParams: { slug: 'slug' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchProducts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3SearchProductsRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3SearchProductsRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3SearchProductsResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3SearchProductsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.searchProducts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/products/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryProducts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3QueryProductsRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3QueryProductsRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3QueryProductsResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3QueryProductsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.queryProducts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/products/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countProducts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3CountProductsRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3CountProductsRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3CountProductsResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3CountProductsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.countProducts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/products/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateProductVariantsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkUpdateProductVariantsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductTypes.BulkUpdateProductVariantsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkUpdateProductVariantsByFilterResponse,
  ambassadorWixStoresCatalogV3ProductTypes.BulkUpdateProductVariantsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkUpdateProductVariantsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/update-variants-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkAdjustProductVariantsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkAdjustProductVariantsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkAdjustProductVariantsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkAdjustProductVariantsByFilterResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkAdjustProductVariantsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkAdjustProductVariantsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/adjust-variants-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkAddInfoSectionsToProductsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkAddInfoSectionsToProductsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkAddInfoSectionsToProductsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkAddInfoSectionsToProductsByFilterResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkAddInfoSectionsToProductsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkAddInfoSectionsToProductsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/add-info-sections-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkAddInfoSectionsToProducts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkAddInfoSectionsToProductsRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkAddInfoSectionsToProductsRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkAddInfoSectionsToProductsResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkAddInfoSectionsToProductsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkAddInfoSectionsToProducts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/add-info-sections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkRemoveInfoSectionsFromProductsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkRemoveInfoSectionsFromProductsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkRemoveInfoSectionsFromProductsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkRemoveInfoSectionsFromProductsByFilterResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkRemoveInfoSectionsFromProductsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkRemoveInfoSectionsFromProductsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/remove-info-sections-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkRemoveInfoSectionsFromProducts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkRemoveInfoSectionsFromProductsRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkRemoveInfoSectionsFromProductsRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkRemoveInfoSectionsFromProductsResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkRemoveInfoSectionsFromProductsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkRemoveInfoSectionsFromProducts(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/remove-info-sections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkAddProductsToCategoriesByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkAddProductsToCategoriesByFilterRequest,
  ambassadorWixStoresCatalogV3ProductTypes.BulkAddProductsToCategoriesByFilterRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkAddProductsToCategoriesByFilterResponse,
  ambassadorWixStoresCatalogV3ProductTypes.BulkAddProductsToCategoriesByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkAddProductsToCategoriesByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/add-to-categories-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkRemoveProductsFromCategoriesByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkRemoveProductsFromCategoriesByFilterRequest,
  ambassadorWixStoresCatalogV3ProductTypes.BulkRemoveProductsFromCategoriesByFilterRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.BulkRemoveProductsFromCategoriesByFilterResponse,
  ambassadorWixStoresCatalogV3ProductTypes.BulkRemoveProductsFromCategoriesByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkRemoveProductsFromCategoriesByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/remove-from-categories-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAllProductsCategory(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.GetAllProductsCategoryRequest,
  ambassadorWixStoresCatalogV3ProductTypes.GetAllProductsCategoryRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.GetAllProductsCategoryResponse,
  ambassadorWixStoresCatalogV3ProductTypes.GetAllProductsCategoryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.getAllProductsCategory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/all-products-category',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateProductTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkUpdateProductTagsRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkUpdateProductTagsRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkUpdateProductTagsResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkUpdateProductTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkUpdateProductTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateProductTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkUpdateProductTagsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkUpdateProductTagsByFilterRequest,
  ambassadorWixStoresCatalogV3ProductUniversalTypes.V3BulkUpdateProductTagsByFilterResponse,
  ambassadorWixStoresCatalogV3ProductTypes.V3BulkUpdateProductTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Product.bulkUpdateProductTagsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/products/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  V3Product as V3ProductOriginal,
  V3ProductTypedPropertiesOneOf as V3ProductTypedPropertiesOneOfOriginal,
  PageUrlV2 as PageUrlV2Original,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  V1Media as V1MediaOriginal,
  ItemImage as ItemImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  PollSettings as PollSettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  TableDataDimensions as TableDataDimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  Media as MediaOriginal,
  ProductMedia as ProductMediaOriginal,
  ProductMediaSetByOneOf as ProductMediaSetByOneOfOriginal,
  ProductMediaMediaOneOf as ProductMediaMediaOneOfOriginal,
  Image as ImageOriginal,
  VideoV2 as VideoV2Original,
  VideoResolution as VideoResolutionOriginal,
  MediaType as MediaTypeOriginal,
  MediaTypeWithLiterals as MediaTypeWithLiteralsOriginal,
  Thumbnail as ThumbnailOriginal,
  MediaItemsInfo as MediaItemsInfoOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  ConnectedOption as ConnectedOptionOriginal,
  ConnectedOptionOptionSettingsOneOf as ConnectedOptionOptionSettingsOneOfOriginal,
  ProductOptionRenderType as ProductOptionRenderTypeOriginal,
  ProductOptionRenderTypeWithLiterals as ProductOptionRenderTypeWithLiteralsOriginal,
  ChoicesSettings as ChoicesSettingsOriginal,
  ConnectedOptionChoice as ConnectedOptionChoiceOriginal,
  ConnectedOptionChoiceValueOneOf as ConnectedOptionChoiceValueOneOfOriginal,
  ChoiceType as ChoiceTypeOriginal,
  ChoiceTypeWithLiterals as ChoiceTypeWithLiteralsOriginal,
  MultipleColors as MultipleColorsOriginal,
  ConnectedModifier as ConnectedModifierOriginal,
  ConnectedModifierModifierSettingsOneOf as ConnectedModifierModifierSettingsOneOfOriginal,
  ModifierRenderType as ModifierRenderTypeOriginal,
  ModifierRenderTypeWithLiterals as ModifierRenderTypeWithLiteralsOriginal,
  FreeTextSettings as FreeTextSettingsOriginal,
  ModifierChoicesSettings as ModifierChoicesSettingsOriginal,
  ConnectedModifierChoice as ConnectedModifierChoiceOriginal,
  ConnectedModifierChoiceValueOneOf as ConnectedModifierChoiceValueOneOfOriginal,
  V3Brand as V3BrandOriginal,
  InfoSection as InfoSectionOriginal,
  Ribbon as RibbonOriginal,
  ProductCategoriesInfo as ProductCategoriesInfoOriginal,
  ProductCategory as ProductCategoryOriginal,
  ProductCategoryIdsInfo as ProductCategoryIdsInfoOriginal,
  PriceRange as PriceRangeOriginal,
  FixedMonetaryAmount as FixedMonetaryAmountOriginal,
  Inventory as InventoryOriginal,
  InventoryAvailabilityStatus as InventoryAvailabilityStatusOriginal,
  InventoryAvailabilityStatusWithLiterals as InventoryAvailabilityStatusWithLiteralsOriginal,
  PreorderStatus as PreorderStatusOriginal,
  PreorderStatusWithLiterals as PreorderStatusWithLiteralsOriginal,
  ProductPreorderAvailability as ProductPreorderAvailabilityOriginal,
  ProductPreorderAvailabilityWithLiterals as ProductPreorderAvailabilityWithLiteralsOriginal,
  ProductType as ProductTypeOriginal,
  ProductTypeWithLiterals as ProductTypeWithLiteralsOriginal,
  PhysicalProperties as PhysicalPropertiesOriginal,
  PricePerUnitSettings as PricePerUnitSettingsOriginal,
  MeasurementUnit as MeasurementUnitOriginal,
  MeasurementUnitWithLiterals as MeasurementUnitWithLiteralsOriginal,
  WeightRange as WeightRangeOriginal,
  PricePerUnitRange as PricePerUnitRangeOriginal,
  PricePerUnitRangePricePerUnit as PricePerUnitRangePricePerUnitOriginal,
  WeightMeasurementUnitInfo as WeightMeasurementUnitInfoOriginal,
  WeightUnit as WeightUnitOriginal,
  WeightUnitWithLiterals as WeightUnitWithLiteralsOriginal,
  BreadcrumbsInfo as BreadcrumbsInfoOriginal,
  BreadCrumb as BreadCrumbOriginal,
  VariantsInfo as VariantsInfoOriginal,
  Variant as VariantOriginal,
  VariantTypedPropertiesOneOf as VariantTypedPropertiesOneOfOriginal,
  OptionChoice as OptionChoiceOriginal,
  OptionChoiceIds as OptionChoiceIdsOriginal,
  OptionChoiceNames as OptionChoiceNamesOriginal,
  PriceInfo as PriceInfoOriginal,
  RevenueDetails as RevenueDetailsOriginal,
  VariantPhysicalProperties as VariantPhysicalPropertiesOriginal,
  PricePerUnit as PricePerUnitOriginal,
  VariantDigitalProperties as VariantDigitalPropertiesOriginal,
  SecuredMedia as SecuredMediaOriginal,
  FileType as FileTypeOriginal,
  FileTypeWithLiterals as FileTypeWithLiteralsOriginal,
  SubscriptionPricesInfo as SubscriptionPricesInfoOriginal,
  SubscriptionPrice as SubscriptionPriceOriginal,
  SubscriptionPricePerUnit as SubscriptionPricePerUnitOriginal,
  InventoryStatus as InventoryStatusOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  SubscriptionDetails as SubscriptionDetailsOriginal,
  Subscription as SubscriptionOriginal,
  SubscriptionCyclesOneOf as SubscriptionCyclesOneOfOriginal,
  SubscriptionFrequency as SubscriptionFrequencyOriginal,
  SubscriptionFrequencyWithLiterals as SubscriptionFrequencyWithLiteralsOriginal,
  SubscriptionDiscount as SubscriptionDiscountOriginal,
  SubscriptionDiscountDiscountOneOf as SubscriptionDiscountDiscountOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  VariantSummary as VariantSummaryOriginal,
  MinVariantPriceInfo as MinVariantPriceInfoOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Background as BackgroundOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  Banner as BannerOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  Backdrop as BackdropOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  MediaReferences as MediaReferencesOriginal,
  MediaReference as MediaReferenceOriginal,
  MediaReferenceIdentifierOneOf as MediaReferenceIdentifierOneOfOriginal,
  Dimensions as DimensionsOriginal,
  DimensionsUnit as DimensionsUnitOriginal,
  DimensionsUnitWithLiterals as DimensionsUnitWithLiteralsOriginal,
  PurchaseEligibility as PurchaseEligibilityOriginal,
  UserCriteria as UserCriteriaOriginal,
  UserCriteriaWithLiterals as UserCriteriaWithLiteralsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  UpdateDocumentsEvent as UpdateDocumentsEventOriginal,
  UpdateDocumentsEventOperationOneOf as UpdateDocumentsEventOperationOneOfOriginal,
  DocumentUpdateOperation as DocumentUpdateOperationOriginal,
  IndexDocument as IndexDocumentOriginal,
  DocumentPayload as DocumentPayloadOriginal,
  DocumentImage as DocumentImageOriginal,
  Enum as EnumOriginal,
  EnumWithLiterals as EnumWithLiteralsOriginal,
  DeleteByIdsOperation as DeleteByIdsOperationOriginal,
  DeleteByFilterOperation as DeleteByFilterOperationOriginal,
  UpdateByFilterOperation as UpdateByFilterOperationOriginal,
  UpdateExistingOperation as UpdateExistingOperationOriginal,
  ProductTagsModified as ProductTagsModifiedOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  SearchIndexingNotification as SearchIndexingNotificationOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  DoNotCallCreateProductRequest as DoNotCallCreateProductRequestOriginal,
  SingleEntityOpsRequestedFields as SingleEntityOpsRequestedFieldsOriginal,
  SingleEntityOpsRequestedFieldsWithLiterals as SingleEntityOpsRequestedFieldsWithLiteralsOriginal,
  DoNotCallCreateProductResponse as DoNotCallCreateProductResponseOriginal,
  DuplicateRibbonErrorData as DuplicateRibbonErrorDataOriginal,
  DuplicateMediaIdAssignedToProduct as DuplicateMediaIdAssignedToProductOriginal,
  GetProductRequest as GetProductRequestOriginal,
  GetProductResponse as GetProductResponseOriginal,
  GetProductBySlugRequest as GetProductBySlugRequestOriginal,
  GetProductBySlugResponse as GetProductBySlugResponseOriginal,
  DoNotCallUpdateProductRequest as DoNotCallUpdateProductRequestOriginal,
  DoNotCallUpdateProductResponse as DoNotCallUpdateProductResponseOriginal,
  VariantsRemoved as VariantsRemovedOriginal,
  UnsupportedFieldMasks as UnsupportedFieldMasksOriginal,
  DeleteProductRequest as DeleteProductRequestOriginal,
  DeleteProductResponse as DeleteProductResponseOriginal,
  SearchProductsRequest as SearchProductsRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  SearchProductsResponse as SearchProductsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  SearchRelatedProductsRequest as SearchRelatedProductsRequestOriginal,
  SearchRelated as SearchRelatedOriginal,
  SearchRelatedDetails as SearchRelatedDetailsOriginal,
  SearchRelatedProductsResponse as SearchRelatedProductsResponseOriginal,
  EventuallyConsistentQueryProductsRequest as EventuallyConsistentQueryProductsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  EventuallyConsistentQueryProductsResponse as EventuallyConsistentQueryProductsResponseOriginal,
  QueryProductsRequest as QueryProductsRequestOriginal,
  QueryProductsResponse as QueryProductsResponseOriginal,
  DeprecatedSearchProductsWithOffsetRequest as DeprecatedSearchProductsWithOffsetRequestOriginal,
  PlatformOffsetSearch as PlatformOffsetSearchOriginal,
  PlatformOffsetSearchPagingMethodOneOf as PlatformOffsetSearchPagingMethodOneOfOriginal,
  CommonSorting as CommonSortingOriginal,
  CommonSortOrder as CommonSortOrderOriginal,
  CommonSortOrderWithLiterals as CommonSortOrderWithLiteralsOriginal,
  CommonAggregation as CommonAggregationOriginal,
  CommonAggregationKindOneOf as CommonAggregationKindOneOfOriginal,
  RangeAggregationRangeBucket as RangeAggregationRangeBucketOriginal,
  ValueAggregationSortType as ValueAggregationSortTypeOriginal,
  ValueAggregationSortTypeWithLiterals as ValueAggregationSortTypeWithLiteralsOriginal,
  ValueAggregationSortDirection as ValueAggregationSortDirectionOriginal,
  ValueAggregationSortDirectionWithLiterals as ValueAggregationSortDirectionWithLiteralsOriginal,
  ValueAggregationMissingValues as ValueAggregationMissingValuesOriginal,
  ValueAggregationMissingValuesWithLiterals as ValueAggregationMissingValuesWithLiteralsOriginal,
  ValueAggregationIncludeMissingValuesOptions as ValueAggregationIncludeMissingValuesOptionsOriginal,
  CommonScalarType as CommonScalarTypeOriginal,
  CommonScalarTypeWithLiterals as CommonScalarTypeWithLiteralsOriginal,
  AggregationValueAggregation as AggregationValueAggregationOriginal,
  AggregationValueAggregationOptionsOneOf as AggregationValueAggregationOptionsOneOfOriginal,
  NestedAggregationNestedAggregationType as NestedAggregationNestedAggregationTypeOriginal,
  NestedAggregationNestedAggregationTypeWithLiterals as NestedAggregationNestedAggregationTypeWithLiteralsOriginal,
  AggregationRangeAggregation as AggregationRangeAggregationOriginal,
  AggregationScalarAggregation as AggregationScalarAggregationOriginal,
  AggregationDateHistogramAggregation as AggregationDateHistogramAggregationOriginal,
  DateHistogramAggregationInterval as DateHistogramAggregationIntervalOriginal,
  DateHistogramAggregationIntervalWithLiterals as DateHistogramAggregationIntervalWithLiteralsOriginal,
  NestedAggregationNestedAggregationItem as NestedAggregationNestedAggregationItemOriginal,
  NestedAggregationNestedAggregationItemKindOneOf as NestedAggregationNestedAggregationItemKindOneOfOriginal,
  CommonAggregationType as CommonAggregationTypeOriginal,
  CommonAggregationTypeWithLiterals as CommonAggregationTypeWithLiteralsOriginal,
  AggregationNestedAggregation as AggregationNestedAggregationOriginal,
  GroupByAggregation as GroupByAggregationOriginal,
  GroupByAggregationKindOneOf as GroupByAggregationKindOneOfOriginal,
  CommonSearchDetails as CommonSearchDetailsOriginal,
  SearchDetailsMode as SearchDetailsModeOriginal,
  SearchDetailsModeWithLiterals as SearchDetailsModeWithLiteralsOriginal,
  PlatformPaging as PlatformPagingOriginal,
  DeprecatedSearchProductsWithOffsetResponse as DeprecatedSearchProductsWithOffsetResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  RetrieveVariantsRequest as RetrieveVariantsRequestOriginal,
  ProductVariantIds as ProductVariantIdsOriginal,
  VariantsCursorPaging as VariantsCursorPagingOriginal,
  VariantsOpsRequestedFields as VariantsOpsRequestedFieldsOriginal,
  VariantsOpsRequestedFieldsWithLiterals as VariantsOpsRequestedFieldsWithLiteralsOriginal,
  RetrieveVariantsResponse as RetrieveVariantsResponseOriginal,
  ProductVariants as ProductVariantsOriginal,
  CountProductsRequest as CountProductsRequestOriginal,
  CountProductsResponse as CountProductsResponseOriginal,
  DoNotCallBulkCreateProductsRequest as DoNotCallBulkCreateProductsRequestOriginal,
  DoNotCallBulkCreateProductsResponse as DoNotCallBulkCreateProductsResponseOriginal,
  V3BulkProductResult as V3BulkProductResultOriginal,
  CommonItemMetadata as CommonItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  DoNotCallBulkUpdateProductsRequest as DoNotCallBulkUpdateProductsRequestOriginal,
  MaskedProduct as MaskedProductOriginal,
  DoNotCallBulkUpdateProductsResponse as DoNotCallBulkUpdateProductsResponseOriginal,
  BulkUpdateProductsByFilterRequest as BulkUpdateProductsByFilterRequestOriginal,
  BulkUpdateProductsByFilterResponse as BulkUpdateProductsByFilterResponseOriginal,
  BulkDeleteProductsRequest as BulkDeleteProductsRequestOriginal,
  BulkDeleteProductsResponse as BulkDeleteProductsResponseOriginal,
  BulkProductResult as BulkProductResultOriginal,
  BulkDeleteProductsByFilterRequest as BulkDeleteProductsByFilterRequestOriginal,
  BulkDeleteProductsByFilterResponse as BulkDeleteProductsByFilterResponseOriginal,
  BulkAddInfoSectionsToProductsByFilterRequest as BulkAddInfoSectionsToProductsByFilterRequestOriginal,
  BulkAddInfoSectionsToProductsByFilterResponse as BulkAddInfoSectionsToProductsByFilterResponseOriginal,
  FulfillerDeleted as FulfillerDeletedOriginal,
  BulkAddInfoSectionsToProductsRequest as BulkAddInfoSectionsToProductsRequestOriginal,
  ProductIdWithRevision as ProductIdWithRevisionOriginal,
  BulkAddInfoSectionsToProductsResponse as BulkAddInfoSectionsToProductsResponseOriginal,
  BulkRemoveInfoSectionsFromProductsByFilterRequest as BulkRemoveInfoSectionsFromProductsByFilterRequestOriginal,
  BulkRemoveInfoSectionsFromProductsByFilterResponse as BulkRemoveInfoSectionsFromProductsByFilterResponseOriginal,
  BulkRemoveInfoSectionsFromProductsRequest as BulkRemoveInfoSectionsFromProductsRequestOriginal,
  BulkRemoveInfoSectionsFromProductsResponse as BulkRemoveInfoSectionsFromProductsResponseOriginal,
  BulkUpdateVariantsByFilterRequest as BulkUpdateVariantsByFilterRequestOriginal,
  BulkUpdateVariantsByFilterResponse as BulkUpdateVariantsByFilterResponseOriginal,
  BulkAdjustProductVariantsByFilterRequest as BulkAdjustProductVariantsByFilterRequestOriginal,
  AdjustValue as AdjustValueOriginal,
  AdjustValueAdjustValueOneOf as AdjustValueAdjustValueOneOfOriginal,
  RoundingStrategy as RoundingStrategyOriginal,
  RoundingStrategyWithLiterals as RoundingStrategyWithLiteralsOriginal,
  UnsignedAdjustValue as UnsignedAdjustValueOriginal,
  UnsignedAdjustValueAdjustValueOneOf as UnsignedAdjustValueAdjustValueOneOfOriginal,
  BulkAdjustProductVariantsByFilterResponse as BulkAdjustProductVariantsByFilterResponseOriginal,
  BulkCreateProductsForMigrationRequest as BulkCreateProductsForMigrationRequestOriginal,
  BulkCreateProductsForMigrationResponse as BulkCreateProductsForMigrationResponseOriginal,
  BulkInventoryItemAction as BulkInventoryItemActionOriginal,
  InventoryItem as InventoryItemOriginal,
  InventoryItemTrackingMethodOneOf as InventoryItemTrackingMethodOneOfOriginal,
  AvailabilityStatus as AvailabilityStatusOriginal,
  AvailabilityStatusWithLiterals as AvailabilityStatusWithLiteralsOriginal,
  PreorderInfo as PreorderInfoOriginal,
  Product as ProductOriginal,
  Brand as BrandOriginal,
  EventType as EventTypeOriginal,
  EventTypeWithLiterals as EventTypeWithLiteralsOriginal,
  CalculateProductInventorPreorderStatusAsyncRequest as CalculateProductInventorPreorderStatusAsyncRequestOriginal,
  CalculateProductInventorPreorderStatusAsyncResponse as CalculateProductInventorPreorderStatusAsyncResponseOriginal,
  PuffUpProductMediaRequest as PuffUpProductMediaRequestOriginal,
  PuffUpProductMediaResponse as PuffUpProductMediaResponseOriginal,
  BulkUpdateProductTagsRequest as BulkUpdateProductTagsRequestOriginal,
  BulkUpdateProductTagsResponse as BulkUpdateProductTagsResponseOriginal,
  BulkUpdateProductTagsResult as BulkUpdateProductTagsResultOriginal,
  BulkUpdateProductTagsByFilterRequest as BulkUpdateProductTagsByFilterRequestOriginal,
  BulkUpdateProductTagsByFilterResponse as BulkUpdateProductTagsByFilterResponseOriginal,
  CreateProductRequest as CreateProductRequestOriginal,
  CreateProductResponse as CreateProductResponseOriginal,
  VariantsNotAlignedWithProduct as VariantsNotAlignedWithProductOriginal,
  VariantNotAlignedWithProduct as VariantNotAlignedWithProductOriginal,
  MissingVariantOptionChoiceErrorData as MissingVariantOptionChoiceErrorDataOriginal,
  MissingVariantOptionErrorData as MissingVariantOptionErrorDataOriginal,
  CreateProductWithInventoryRequest as CreateProductWithInventoryRequestOriginal,
  ProductWithInventory as ProductWithInventoryOriginal,
  ProductWithInventoryTypedPropertiesOneOf as ProductWithInventoryTypedPropertiesOneOfOriginal,
  V3VariantsInfo as V3VariantsInfoOriginal,
  VariantWithInventory as VariantWithInventoryOriginal,
  VariantWithInventoryTypedPropertiesOneOf as VariantWithInventoryTypedPropertiesOneOfOriginal,
  InventoryItemComposite as InventoryItemCompositeOriginal,
  InventoryItemCompositeTrackingMethodOneOf as InventoryItemCompositeTrackingMethodOneOfOriginal,
  OptionChoiceReferences as OptionChoiceReferencesOriginal,
  V3OptionChoiceIds as V3OptionChoiceIdsOriginal,
  V3OptionChoiceNames as V3OptionChoiceNamesOriginal,
  CreateProductWithInventoryResponse as CreateProductWithInventoryResponseOriginal,
  BulkInventoryItemResults as BulkInventoryItemResultsOriginal,
  BulkInventoryItemResult as BulkInventoryItemResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  CommonBulkActionMetadata as CommonBulkActionMetadataOriginal,
  UpdateProductRequest as UpdateProductRequestOriginal,
  UpdateProductResponse as UpdateProductResponseOriginal,
  UpdateProductWithInventoryRequest as UpdateProductWithInventoryRequestOriginal,
  UpdateProductWithInventoryResponse as UpdateProductWithInventoryResponseOriginal,
  BulkCreateProductsRequest as BulkCreateProductsRequestOriginal,
  BulkCreateProductsResponse as BulkCreateProductsResponseOriginal,
  CatalogV3BulkProductResult as CatalogV3BulkProductResultOriginal,
  WixCommonItemMetadata as WixCommonItemMetadataOriginal,
  InvalidDigitalFileIds as InvalidDigitalFileIdsOriginal,
  BulkCreateProductsWithInventoryRequest as BulkCreateProductsWithInventoryRequestOriginal,
  BulkCreateProductsWithInventoryResponse as BulkCreateProductsWithInventoryResponseOriginal,
  BulkProductResults as BulkProductResultsOriginal,
  BulkUpdateProductsRequest as BulkUpdateProductsRequestOriginal,
  V3MaskedProduct as V3MaskedProductOriginal,
  BulkUpdateProductsResponse as BulkUpdateProductsResponseOriginal,
  BulkUpdateProductsWithInventoryRequest as BulkUpdateProductsWithInventoryRequestOriginal,
  MaskedProductWithInventory as MaskedProductWithInventoryOriginal,
  BulkUpdateProductsWithInventoryResponse as BulkUpdateProductsWithInventoryResponseOriginal,
  V3BulkUpdateProductsByFilterRequest as V3BulkUpdateProductsByFilterRequestOriginal,
  WixCommonSearchDetails as WixCommonSearchDetailsOriginal,
  CommonSearchDetailsMode as CommonSearchDetailsModeOriginal,
  CommonSearchDetailsModeWithLiterals as CommonSearchDetailsModeWithLiteralsOriginal,
  V3BulkUpdateProductsByFilterResponse as V3BulkUpdateProductsByFilterResponseOriginal,
  V3DeleteProductRequest as V3DeleteProductRequestOriginal,
  V3DeleteProductResponse as V3DeleteProductResponseOriginal,
  V3BulkDeleteProductsRequest as V3BulkDeleteProductsRequestOriginal,
  V3BulkDeleteProductsResponse as V3BulkDeleteProductsResponseOriginal,
  BulkDeleteProductsResponseBulkProductResult as BulkDeleteProductsResponseBulkProductResultOriginal,
  V3BulkDeleteProductsByFilterRequest as V3BulkDeleteProductsByFilterRequestOriginal,
  V3BulkDeleteProductsByFilterResponse as V3BulkDeleteProductsByFilterResponseOriginal,
  V3GetProductRequest as V3GetProductRequestOriginal,
  V3GetProductResponse as V3GetProductResponseOriginal,
  V3GetProductBySlugRequest as V3GetProductBySlugRequestOriginal,
  V3GetProductBySlugResponse as V3GetProductBySlugResponseOriginal,
  V3SearchProductsRequest as V3SearchProductsRequestOriginal,
  CommonCursorSearch as CommonCursorSearchOriginal,
  CommonCursorSearchPagingMethodOneOf as CommonCursorSearchPagingMethodOneOfOriginal,
  WixCommonSorting as WixCommonSortingOriginal,
  WixCommonSortOrder as WixCommonSortOrderOriginal,
  WixCommonSortOrderWithLiterals as WixCommonSortOrderWithLiteralsOriginal,
  WixCommonAggregation as WixCommonAggregationOriginal,
  WixCommonAggregationKindOneOf as WixCommonAggregationKindOneOfOriginal,
  AggregationRangeAggregationRangeBucket as AggregationRangeAggregationRangeBucketOriginal,
  AggregationValueAggregationSortType as AggregationValueAggregationSortTypeOriginal,
  AggregationValueAggregationSortTypeWithLiterals as AggregationValueAggregationSortTypeWithLiteralsOriginal,
  AggregationValueAggregationSortDirection as AggregationValueAggregationSortDirectionOriginal,
  AggregationValueAggregationSortDirectionWithLiterals as AggregationValueAggregationSortDirectionWithLiteralsOriginal,
  AggregationValueAggregationMissingValues as AggregationValueAggregationMissingValuesOriginal,
  AggregationValueAggregationMissingValuesWithLiterals as AggregationValueAggregationMissingValuesWithLiteralsOriginal,
  AggregationValueAggregationIncludeMissingValuesOptions as AggregationValueAggregationIncludeMissingValuesOptionsOriginal,
  WixCommonScalarType as WixCommonScalarTypeOriginal,
  WixCommonScalarTypeWithLiterals as WixCommonScalarTypeWithLiteralsOriginal,
  CommonAggregationValueAggregation as CommonAggregationValueAggregationOriginal,
  CommonAggregationValueAggregationOptionsOneOf as CommonAggregationValueAggregationOptionsOneOfOriginal,
  AggregationNestedAggregationNestedAggregationType as AggregationNestedAggregationNestedAggregationTypeOriginal,
  AggregationNestedAggregationNestedAggregationTypeWithLiterals as AggregationNestedAggregationNestedAggregationTypeWithLiteralsOriginal,
  CommonAggregationRangeAggregation as CommonAggregationRangeAggregationOriginal,
  CommonAggregationScalarAggregation as CommonAggregationScalarAggregationOriginal,
  CommonAggregationDateHistogramAggregation as CommonAggregationDateHistogramAggregationOriginal,
  AggregationDateHistogramAggregationInterval as AggregationDateHistogramAggregationIntervalOriginal,
  AggregationDateHistogramAggregationIntervalWithLiterals as AggregationDateHistogramAggregationIntervalWithLiteralsOriginal,
  AggregationNestedAggregationNestedAggregationItem as AggregationNestedAggregationNestedAggregationItemOriginal,
  AggregationNestedAggregationNestedAggregationItemKindOneOf as AggregationNestedAggregationNestedAggregationItemKindOneOfOriginal,
  WixCommonAggregationType as WixCommonAggregationTypeOriginal,
  WixCommonAggregationTypeWithLiterals as WixCommonAggregationTypeWithLiteralsOriginal,
  CommonAggregationNestedAggregation as CommonAggregationNestedAggregationOriginal,
  CommonCursorPaging as CommonCursorPagingOriginal,
  V3SearchProductsResponse as V3SearchProductsResponseOriginal,
  CommonCursorPagingMetadata as CommonCursorPagingMetadataOriginal,
  CommonCursors as CommonCursorsOriginal,
  CommonAggregationData as CommonAggregationDataOriginal,
  ValueResultsValueAggregationResult as ValueResultsValueAggregationResultOriginal,
  RangeResultsRangeAggregationResult as RangeResultsRangeAggregationResultOriginal,
  AggregationResultsNestedAggregationResults as AggregationResultsNestedAggregationResultsOriginal,
  AggregationResultsNestedAggregationResultsResultOneOf as AggregationResultsNestedAggregationResultsResultOneOfOriginal,
  AggregationResultsValueResults as AggregationResultsValueResultsOriginal,
  AggregationResultsRangeResults as AggregationResultsRangeResultsOriginal,
  AggregationDataAggregationResultsScalarResult as AggregationDataAggregationResultsScalarResultOriginal,
  GroupByValueResultsNestedValueAggregationResult as GroupByValueResultsNestedValueAggregationResultOriginal,
  NestedResultsValueResult as NestedResultsValueResultOriginal,
  NestedResultsRangeResult as NestedResultsRangeResultOriginal,
  NestedResultsScalarResult as NestedResultsScalarResultOriginal,
  NestedResultsNestedResultValue as NestedResultsNestedResultValueOriginal,
  NestedResultsNestedResultValueResultOneOf as NestedResultsNestedResultValueResultOneOfOriginal,
  NestedResultsResults as NestedResultsResultsOriginal,
  DateHistogramResultsDateHistogramResult as DateHistogramResultsDateHistogramResultOriginal,
  AggregationResultsGroupByValueResults as AggregationResultsGroupByValueResultsOriginal,
  AggregationResultsDateHistogramResults as AggregationResultsDateHistogramResultsOriginal,
  AggregationResultsNestedResults as AggregationResultsNestedResultsOriginal,
  AggregationDataAggregationResults as AggregationDataAggregationResultsOriginal,
  AggregationDataAggregationResultsResultOneOf as AggregationDataAggregationResultsResultOneOfOriginal,
  V3QueryProductsRequest as V3QueryProductsRequestOriginal,
  CommonCursorQuery as CommonCursorQueryOriginal,
  CommonCursorQueryPagingMethodOneOf as CommonCursorQueryPagingMethodOneOfOriginal,
  V3QueryProductsResponse as V3QueryProductsResponseOriginal,
  V3CountProductsRequest as V3CountProductsRequestOriginal,
  V3CountProductsResponse as V3CountProductsResponseOriginal,
  BulkUpdateProductVariantsByFilterRequest as BulkUpdateProductVariantsByFilterRequestOriginal,
  BulkUpdateProductVariantsByFilterResponse as BulkUpdateProductVariantsByFilterResponseOriginal,
  V3BulkAdjustProductVariantsByFilterRequest as V3BulkAdjustProductVariantsByFilterRequestOriginal,
  V3AdjustValue as V3AdjustValueOriginal,
  V3AdjustValueAdjustValueOneOf as V3AdjustValueAdjustValueOneOfOriginal,
  BulkAdjustProductVariantsByFilterRequestRoundingStrategy as BulkAdjustProductVariantsByFilterRequestRoundingStrategyOriginal,
  BulkAdjustProductVariantsByFilterRequestRoundingStrategyWithLiterals as BulkAdjustProductVariantsByFilterRequestRoundingStrategyWithLiteralsOriginal,
  V3UnsignedAdjustValue as V3UnsignedAdjustValueOriginal,
  V3UnsignedAdjustValueAdjustValueOneOf as V3UnsignedAdjustValueAdjustValueOneOfOriginal,
  V3BulkAdjustProductVariantsByFilterResponse as V3BulkAdjustProductVariantsByFilterResponseOriginal,
  V3BulkAddInfoSectionsToProductsByFilterRequest as V3BulkAddInfoSectionsToProductsByFilterRequestOriginal,
  V3BulkAddInfoSectionsToProductsByFilterResponse as V3BulkAddInfoSectionsToProductsByFilterResponseOriginal,
  V3BulkAddInfoSectionsToProductsRequest as V3BulkAddInfoSectionsToProductsRequestOriginal,
  V3ProductIdWithRevision as V3ProductIdWithRevisionOriginal,
  V3BulkAddInfoSectionsToProductsResponse as V3BulkAddInfoSectionsToProductsResponseOriginal,
  V3BulkRemoveInfoSectionsFromProductsByFilterRequest as V3BulkRemoveInfoSectionsFromProductsByFilterRequestOriginal,
  V3BulkRemoveInfoSectionsFromProductsByFilterResponse as V3BulkRemoveInfoSectionsFromProductsByFilterResponseOriginal,
  V3BulkRemoveInfoSectionsFromProductsRequest as V3BulkRemoveInfoSectionsFromProductsRequestOriginal,
  V3BulkRemoveInfoSectionsFromProductsResponse as V3BulkRemoveInfoSectionsFromProductsResponseOriginal,
  BulkCreateProductsWithInventoryForMigrationRequest as BulkCreateProductsWithInventoryForMigrationRequestOriginal,
  ProductWithInventoryForMigration as ProductWithInventoryForMigrationOriginal,
  ProductWithInventoryForMigrationTypedPropertiesOneOf as ProductWithInventoryForMigrationTypedPropertiesOneOfOriginal,
  VariantsInfoForMigration as VariantsInfoForMigrationOriginal,
  VariantWithInventoryForMigration as VariantWithInventoryForMigrationOriginal,
  VariantWithInventoryForMigrationTypedPropertiesOneOf as VariantWithInventoryForMigrationTypedPropertiesOneOfOriginal,
  InventoryItemCompositeForMigration as InventoryItemCompositeForMigrationOriginal,
  InventoryItemCompositeForMigrationTrackingMethodOneOf as InventoryItemCompositeForMigrationTrackingMethodOneOfOriginal,
  OptionChoiceReferencesForMigration as OptionChoiceReferencesForMigrationOriginal,
  OptionChoiceIdsForMigration as OptionChoiceIdsForMigrationOriginal,
  BulkCreateProductsWithInventoryForMigrationResponse as BulkCreateProductsWithInventoryForMigrationResponseOriginal,
  BulkAddProductsToCategoriesByFilterRequest as BulkAddProductsToCategoriesByFilterRequestOriginal,
  BulkAddProductsToCategoriesByFilterResponse as BulkAddProductsToCategoriesByFilterResponseOriginal,
  BulkRemoveProductsFromCategoriesByFilterRequest as BulkRemoveProductsFromCategoriesByFilterRequestOriginal,
  BulkRemoveProductsFromCategoriesByFilterResponse as BulkRemoveProductsFromCategoriesByFilterResponseOriginal,
  GetAllProductsCategoryRequest as GetAllProductsCategoryRequestOriginal,
  GetAllProductsCategoryResponse as GetAllProductsCategoryResponseOriginal,
  TreeReference as TreeReferenceOriginal,
  V3BulkUpdateProductTagsRequest as V3BulkUpdateProductTagsRequestOriginal,
  V3BulkUpdateProductTagsResponse as V3BulkUpdateProductTagsResponseOriginal,
  BulkUpdateProductTagsResponseBulkUpdateProductTagsResult as BulkUpdateProductTagsResponseBulkUpdateProductTagsResultOriginal,
  V3BulkUpdateProductTagsByFilterRequest as V3BulkUpdateProductTagsByFilterRequestOriginal,
  V3BulkUpdateProductTagsByFilterResponse as V3BulkUpdateProductTagsByFilterResponseOriginal,
  CreateProductApplicationErrors as CreateProductApplicationErrorsOriginal,
  CreateProductValidationErrors as CreateProductValidationErrorsOriginal,
  CreateProductWithInventoryApplicationErrors as CreateProductWithInventoryApplicationErrorsOriginal,
  CreateProductWithInventoryValidationErrors as CreateProductWithInventoryValidationErrorsOriginal,
  UpdateProductApplicationErrors as UpdateProductApplicationErrorsOriginal,
  UpdateProductValidationErrors as UpdateProductValidationErrorsOriginal,
  UpdateProductWithInventoryApplicationErrors as UpdateProductWithInventoryApplicationErrorsOriginal,
  UpdateProductWithInventoryValidationErrors as UpdateProductWithInventoryValidationErrorsOriginal,
  BulkCreateProductsApplicationErrors as BulkCreateProductsApplicationErrorsOriginal,
  BulkCreateProductsValidationErrors as BulkCreateProductsValidationErrorsOriginal,
  BulkCreateProductsWithInventoryApplicationErrors as BulkCreateProductsWithInventoryApplicationErrorsOriginal,
  BulkCreateProductsWithInventoryValidationErrors as BulkCreateProductsWithInventoryValidationErrorsOriginal,
  BulkUpdateProductsApplicationErrors as BulkUpdateProductsApplicationErrorsOriginal,
  BulkUpdateProductsValidationErrors as BulkUpdateProductsValidationErrorsOriginal,
  BulkUpdateProductsWithInventoryApplicationErrors as BulkUpdateProductsWithInventoryApplicationErrorsOriginal,
  BulkUpdateProductsWithInventoryValidationErrors as BulkUpdateProductsWithInventoryValidationErrorsOriginal,
  BulkUpdateProductsByFilterApplicationErrors as BulkUpdateProductsByFilterApplicationErrorsOriginal,
  BulkUpdateProductsByFilterValidationErrors as BulkUpdateProductsByFilterValidationErrorsOriginal,
  BulkDeleteProductsValidationErrors as BulkDeleteProductsValidationErrorsOriginal,
  GetProductApplicationErrors as GetProductApplicationErrorsOriginal,
  GetProductBySlugApplicationErrors as GetProductBySlugApplicationErrorsOriginal,
  SearchProductsApplicationErrors as SearchProductsApplicationErrorsOriginal,
  QueryProductsApplicationErrors as QueryProductsApplicationErrorsOriginal,
  CountProductsApplicationErrors as CountProductsApplicationErrorsOriginal,
  BulkUpdateProductVariantsByFilterApplicationErrors as BulkUpdateProductVariantsByFilterApplicationErrorsOriginal,
  BulkUpdateProductVariantsByFilterValidationErrors as BulkUpdateProductVariantsByFilterValidationErrorsOriginal,
  BulkAdjustProductVariantsByFilterApplicationErrors as BulkAdjustProductVariantsByFilterApplicationErrorsOriginal,
  BulkAdjustProductVariantsByFilterValidationErrors as BulkAdjustProductVariantsByFilterValidationErrorsOriginal,
  BulkAddInfoSectionsToProductsByFilterApplicationErrors as BulkAddInfoSectionsToProductsByFilterApplicationErrorsOriginal,
  BulkAddInfoSectionsToProductsApplicationErrors as BulkAddInfoSectionsToProductsApplicationErrorsOriginal,
  BulkUpdateProductTagsApplicationErrors as BulkUpdateProductTagsApplicationErrorsOriginal,
  BulkUpdateProductTagsByFilterApplicationErrors as BulkUpdateProductTagsByFilterApplicationErrorsOriginal,
} from './stores-catalog-v3-product-products-v-3.types.js';
